import * as Yup from 'yup';

const stepSevenSchema = Yup.object().shape({
  militaryNotes: Yup.string().when('military', {
    is: (value) => value === 'us_military' || value === 'military',
    then: Yup.string().required('This field is required'),
  }),
  athlete: Yup.string(),
  sports: Yup.string().when('athlete', {
    is: (value) => value === 'Club' || value === 'Varsity',
    then: Yup.string().required('This field is required'),
  }),
});

export default stepSevenSchema;
